function JobStatsTable({ queueData }) {
  return (
    <>
      <h2>Job Stats</h2>
      {queueData && queueData?.counts ? (
        <table>
          <tbody>
            {Object.entries(queueData.counts).map(([key, value]) => (
              <tr key={key}>
                <td>{key.charAt(0).toUpperCase() + key.slice(1)}:</td>
                <td>{value}</td>
              </tr>
            ))}
          </tbody>
        </table>
      ) : (
        '-'
      )}
    </>
  );
}

export default JobStatsTable;
